// Desktop nav — hover-triggered mega menu with keyboard fallback
function openItem(item) {
    const toggle = item.querySelector('.site-nav-toggle');
    const mega   = item.querySelector('.site-nav-mega');
    item.classList.add('dropdown-open');
    toggle?.setAttribute('aria-expanded', 'true');
    mega?.setAttribute('aria-hidden', 'false');
}

function closeItem(item) {
    const toggle = item.querySelector('.site-nav-toggle');
    const mega   = item.querySelector('.site-nav-mega');
    item.classList.remove('dropdown-open');
    toggle?.setAttribute('aria-expanded', 'false');
    mega?.setAttribute('aria-hidden', 'true');
}

function closeAll() {
    document.querySelectorAll('.site-nav-item.dropdown-open').forEach(closeItem);
}

document.querySelectorAll('.site-nav-item.has-dropdown').forEach(item => {
    let closeTimer;

    item.addEventListener('mouseenter', () => {
        clearTimeout(closeTimer);
        closeAll();
        openItem(item);
    });

    item.addEventListener('mouseleave', () => {
        closeTimer = setTimeout(() => closeItem(item), 120);
    });

    // Keep open if mouse re-enters the mega panel
    item.querySelector('.site-nav-mega')?.addEventListener('mouseenter', () => {
        clearTimeout(closeTimer);
    });

    item.querySelector('.site-nav-mega')?.addEventListener('mouseleave', () => {
        closeTimer = setTimeout(() => closeItem(item), 120);
    });

    // Keyboard: toggle on Enter/Space for accessibility
    item.querySelector('.site-nav-toggle')?.addEventListener('click', () => {
        const expanded = item.classList.contains('dropdown-open');
        expanded ? closeItem(item) : (closeAll(), openItem(item));
    });
});

// Close on Escape
document.addEventListener('keydown', e => {
    if (e.key === 'Escape') closeAll();
});
